import React, { useEffect,useState } from 'react'
import { Link } from 'react-router-dom'
import toast, { Toaster } from 'react-hot-toast';
import config from "../coreFIles/config";
import Header from '../directives/header'
import Leftnav from '../directives/leftSidebar'
import Rightnav from '../directives/rightSidebar'
import Footer from '../directives/footer'
import Cookies from 'js-cookie'
import { getContentAction } from '../Action/action';
import { getDomainStyles } from '../utils/staticDomainData';
import { getDomainIdWithData } from '../utils/domainHelpers';

const Domainid = getDomainIdWithData();

const Terms = () => {
	// Style state for reactive styling - use static domain data
	const [Style, setStyle] = useState([]);
	
	useEffect(() => {
		const updateStyles = () => {
			try {
				const domainId = Domainid?.domain_id || 0;
				const domainStyles = getDomainStyles(domainId);
				setStyle(domainStyles || []);
			} catch (error) {
				console.error('Error getting domain styles in Terms:', error);
				setStyle([]);
			}
		};
		
		updateStyles();
		const interval = setInterval(updateStyles, 500);
		return () => clearInterval(interval);
	}, []);
	
	// Style values
	const getStyleValue = (key) => {
		if (Style && Array.isArray(Style) && Style.length > 0 && Style[0] && Style[0][key]) {
			return `#${Style[0][key]}`;
		}
		return '';
	};
	const headerMenuColor = getStyleValue('header_menu');

	const [content, setcontent] = useState({});
	const [spinloader, setspinloader] = useState(0);
	useEffect(() => {
		setspinloader(1)		
		getcontentAPI();
	},[])
	const getcontentAPI = async () => {
		let res = await getContentAction({contentId:5,domain_id:Domainid?.domain_id});
		if (res.success) {
			if(!res.data){
				window.location.href = `${config.baseUrl}`
			}
			setcontent(res.data);
		}
		setspinloader(0)
	};	
	
	
	
	
	
	
	return(
		<>
			<Header />
			
			<div className="add-section mb-3">
				<div className="container">
					<div className="row">
						<div className="col-lg-3">
							<Leftnav />
						</div>
						<div className="col-lg-6">
							<Toaster />							
							<div className="classification-section">						
								 {spinloader === 0 ? (
								  <>
									<h2 className="page-heading"style={{background:headerMenuColor}}>{ content?.title }</h2>
									<div dangerouslySetInnerHTML={{ __html: content?.content }}></div>
								  </>
								) : (							
								  <div className="loaderDiv">
									<img className="loaderImg" src={config.baseUrl + "img/loader.gif"} height={50} width={50} />
								  </div>
								)}

							</div>
						</div>
						<div className="col-lg-3">
							<Rightnav />
						</div>
					</div>
				</div>
			</div>
			
			<Footer />
		</>
	)
	
}

export default Terms;
